import { createRequestTypes } from 'common/websocket-redux';

export const SET_FEE = createRequestTypes('admin/SET_FEE');
export const RESET_STATUS = 'admin/RESET_STATUS';
